import Vue from 'vue'

/**
   * Adds an promise-like object with resolve/reject methods as the last argument, and returns a promise.
   * @param topic The topic to emit
   * @param varargs A 0..n arguments to send to the receiver
   * @return {Promise<any>} A promise with the result.
   * The receiver must call resolve or reject on the final argument.
   */
Vue.prototype.$emitPromise = function (topic, varargs) {
  return new Promise((resolve, reject) => {
    const arr = Array.from(arguments)
    let invoked = false
    const promiseLike = {
      resolve: val => {
        if (!invoked) {
          invoked = true
          resolve(val)
        }
      },
      reject: val => {
        if (!invoked) {
          invoked = true
          reject(val)
        }
      }
    }
    arr.push(promiseLike)
    this.$emit.apply(this, arr)
  })
}
